import RegisterSimpleContainer from "../../../../Components/OtherPages/Authentication/RegisterSimple/RegisterSimple"

const RegisterSimple = () => {
  return (
    <div className='page-body'>
      <RegisterSimpleContainer />
    </div>
  )
}

export default RegisterSimple